<div class="progress-circle" [title]="tooltipText">
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10.8"
      r="9"
      fill="none"
      stroke="#E5E7EB"
      stroke-width="2"
    />
    <circle
      cx="10"
      cy="10.8"
      r="9"
      fill="none"
      stroke="#2DBBFC"
      stroke-width="2"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 10 10.8"
        to="360 10 10.8"
        dur="5s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
</div>
